const updateAdmissionPageInfo = (data) => (dispatch) => {
  const val = data.data;
  const values = ["Bachelors", "Masters"];
  if (val.length > 0) {
    const coursesSubjectsPresent = values.every((value) => {
      return Object.keys(val[0].info).includes(value);
    });
    if (val[0].registration_acceptance_time.start !== "" && val[0].registration_acceptance_time.end !== "" && coursesSubjectsPresent) {
      dispatch({type: "UPDATE_ADMISSIONS_OPEN_INFO", payload: true});
      dispatch({
        type: "SAVE_ADMISSION_PAGE_INFO",
        payload: {
          year: val[0].year,
          registration_acceptance_time: val[0].registration_acceptance_time,
          info: {
            Bachelors: deStructureCoursesSubjects(val[0].info.Bachelors),
            Masters: deStructureCoursesSubjects(val[0].info.Masters),
          },
        },
      });
    } else {
      dispatch({
        type: "UPDATE_ADMISSIONS_OPEN_INFO",
        payload: false,
      });
      dispatch({
        type: "SAVE_ADMISSION_PAGE_INFO",
        payload: {
          year: "",
          registration_acceptance_time: {},
          info: {},
        },
      });
    }
  }
};
const deStructureCoursesSubjects  = (info) => {
  const courseObj = info;
  const newFinalResult = [];
  const parsedObj = JSON.parse(courseObj);
  Object.keys(parsedObj).forEach((val, index) => {
    newFinalResult.push({
      ...parsedObj[val],
      subjects: [...parsedObj[val].additional_subjects, ...parsedObj[val].main_subjects],
      subjectGroups: [...parsedObj[val].subjectGroups],
    });
  });
  return newFinalResult;
};


export { updateAdmissionPageInfo };
